/**
 * Iframe Security Configuration
 *
 * Centralized configuration for iframe access control.
 * To add new allowed domains, update the ALLOWED_DOMAINS array.
 */

export interface AllowedDomainConfig {
  /** Regex pattern for matching the domain */
  pattern: RegExp;
  /** Human-readable domain pattern for display */
  displayPattern: string;
  /** Whether HTTP is allowed (for localhost/development) */
  allowHttp?: boolean;
}

/**
 * Configuration for allowed iframe parent domains
 * Add new domains here - both pattern and displayPattern will be used
 */
export const ALLOWED_DOMAINS: AllowedDomainConfig[] = [
  {
    pattern: /^https:\/\/[a-zA-Z0-9-]+\.lightning\.force\.com$/,
    displayPattern: 'https://*.lightning.force.com',
  },
  {
    // Add pattern for sandbox instances
    pattern: /^https:\/\/[a-zA-Z0-9-]+--sandbox\.sandbox\.lightning\.force\.com$/,
    displayPattern: 'https://*--sandbox.sandbox.lightning.force.com',
  },
  {
    pattern: /^https:\/\/[a-zA-Z0-9-]+\.my\.salesforce\.com$/,
    displayPattern: 'https://*.my.salesforce.com',
  },
  {
    pattern: /^https:\/\/[a-zA-Z0-9-]+\.vf\.force\.com$/,
    displayPattern: 'https://*.vf.force.com',
  },
  {
    pattern: /^http:\/\/localhost:5500$/,
    displayPattern: 'http://localhost:5500',
    allowHttp: true,
  },
  {
    pattern: /^http:\/\/127\.0\.0\.1:5500$/,
    displayPattern: 'http://127.0.0.1:5500',
    allowHttp: true,
  },
];

/**
 * Get display patterns for all allowed domains
 */
export function getAllowedDomainPatterns(): string[] {
  return ALLOWED_DOMAINS.map((domain) => domain.displayPattern);
}

/**
 * Check if a domain configuration allows HTTP protocol
 */
export function domainAllowsHttp(domain: AllowedDomainConfig): boolean {
  return domain.allowHttp === true;
}
